<template>
	<div class="select-option" :class="{ selected: isSelected }" @click="optionClick">
		<span class="title">
			<slot></slot>
		</span>
	</div>
</template>

<script>
export default {
	name: 'selectOption',
	components: {},
	props: {
		value: {
			type: [String, Number],
			defalut: ''
		}
	},
	data() {
		return {}
	},
	computed: {
		selectValue() {
			return (this.$parent && this.$parent.selectValue) || 0
		},
		isSelected() {
			return (
				this.selectValue === this.value ||
				(Array.isArray(this.selectValue) && this.selectValue.includes(this.value))
			)
		}
	},
	watch: {},
	methods: {
		optionClick() {
			this.$emit('click')
			this.$parent && this.$parent.optionClick && this.$parent.optionClick(this.value)
		}
	},
	created() {},
	mounted() {}
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
